import { render, staticRenderFns } from "./ArticleCategoryCreateEditForm.vue?vue&type=template&id=1368398a&scoped=true&"
import script from "./ArticleCategoryCreateEditForm.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryCreateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCategoryCreateEditForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleCategoryCreateEditForm.vue?vue&type=style&index=1&id=1368398a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368398a",
  null
  
)

export default component.exports